import { string as yupString, object as yupObject } from 'yup';

export const VALIDATION_EMAIL_ERROR = 'Invalid email format';

export const emailValidator = yupString().email().required();

export const saveProjectFormValidator = yupObject().shape({
    email: emailValidator,
});
